import { render } from "./platformReceipt.vue?vue&type=template&id=b20cd0be&scoped=true"
import script from "./platformReceipt.vue?vue&type=script&lang=js"
export * from "./platformReceipt.vue?vue&type=script&lang=js"

import "./platformReceipt.vue?vue&type=style&index=0&id=b20cd0be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b20cd0be"]])

export default __exports__